module.exports = __webpack_public_path__ + "img/children_text.5dc05012.svg";